// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { CartCollectionResult } from "@insite/client-framework/Services/CartService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { CartCollectionModel } from "@insite/client-framework/Types/ApiModels";
import { Draft } from "immer";

export type RecentSavedCartsState = Readonly<{
    loading: boolean;
    value: CartCollectionResult;
}>;

export const initialXRecentSavedCarts: RecentSavedCartsState = {
    loading: false,
    value: {
        carts: undefined,
        pagination: null,
    },
};

const reducer = {
    "xRecentSavedCarts/SetLoading": (draft: Draft<RecentSavedCartsState>, action: { loading: boolean }) => {
        draft.loading = action.loading;
    },
    "xRecentSavedCarts/SetData": (draft: Draft<RecentSavedCartsState>, action: { data: CartCollectionModel }) => {
        draft.value.carts = action.data.carts || [];
        draft.loading = false;
    },
    "xRecentSavedCarts/ResetData": (draft: Draft<RecentSavedCartsState>) => {
        draft.value.carts = undefined;
    },
};

const xRecentSavedCarts = createTypedReducerWithImmer(initialXRecentSavedCarts, reducer);

(reducers as any).xRecentSavedCarts = xRecentSavedCarts;

export type xRecentSavedCartsState = {
    xRecentSavedCarts: RecentSavedCartsState;
} & ApplicationState;

type xRecentSavedCartsReducers = {
    [key: string]: typeof xRecentSavedCarts;
};

export type xRecentSavedCartsActions =
    | Parameters<xRecentSavedCartsReducers[keyof xRecentSavedCartsReducers]>[1]
    | AnyAction;
